export default function ($http) {
    localStorage.removeItem('token');

    $http({
        method: 'GET',
        url: encodeURI('/sts/connect/endsession?post_logout_uri=/')
    }).then(() => window.location = '/');
}



// WEBPACK FOOTER //
// ./Client/app/account/controllers/logout/logoutCtrl.js